import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { ApplicationContext } from "../../context/application_ctx";
import {
  IconButtonMA,
  VisuallyHiddenInput,
} from "../../styles/styledComponents";
import { Close, Upload } from "@mui/icons-material";
import { HttpStatusCode } from "axios";
import { theme } from "../../styles/theme";
import { font } from "../../styles/font";
import { ButtonCustom } from "../button";
import { uploadCVS } from "../../api/controllers/dashboardController";

export default function UploadEmployeeDialog() {
  // context
  const {
    isOpenUploadEmployeeDialog,
    setIsOpenUploadEmployeeDialog,
    setProfileSnack,
    setError,
    // addRowEmp,
    // setAddRowEmp,
    registerDetails,
  } = useContext(ApplicationContext);

  // const [epId, setEpId] = useState("")
  const [epName, setEpName] = useState("");
  const [epEmail, setEpEmail] = useState("");
  const [epDesignation, setEpDesignation] = useState("");
  const [licenseStatus, setLicenseStatus] = useState("unallocated");

  const [apiLoader, setApiLoader] = useState(false);
  const [dragHighlight, setDragHighlight] = useState(false);
  // const [reloadEmployees, setReloadEmployees] = useState(false);
  const [csvFile, setCsvFile] = useState({});

  function handleCloseRegisterDialog() {
    setIsOpenUploadEmployeeDialog(false);
  }

  const onDrop = async (e) => {
    setApiLoader(true);
    console.log(e.dataTransfer.files[0]);
    e.preventDefault();
    if (e.dataTransfer.files[0].type === "text/csv") {
      // setCsvFile(e.dataTransfer.files[0]);
      await uploadDoc(e.dataTransfer.files[0]);
    } else {
      setApiLoader(false);
      setDragHighlight(false);
      setError("only CSV files are allowed to upload");
      // setOnBoardSnack(true);
      setProfileSnack(true);
    }
  };

  const onFileSelect = async (e) => {
    setApiLoader(true);
    console.log(e.target.files[0]);
    e.preventDefault();

    await uploadDoc(e.target.files[0]);
  };

  const uploadDoc = async (file) => {
    try {
      let response = await uploadCVS({
        file,
      });
      console.log(response, "responseLogin");
      if (response.status === HttpStatusCode.Ok) {
        setCsvFile(file);

        setApiLoader(false);

        setDragHighlight(false);
        setError(response.data.message);
        // setOnBoardSnack(true);
        setProfileSnack(true);
        // setReloadEmployees(true);
        // setTimeout(() => {
        //     setReloadEmployees(false);
        // }, 400);
      }
      if (response.status === HttpStatusCode.BadRequest) {
      }
      if (response.status === HttpStatusCode.InternalServerError) {
        setApiLoader(false);
        setDragHighlight(false);
        setError(response.data.message);
        // setOnBoardSnack(true);
        setProfileSnack(true);
      }

      if (response.status === HttpStatusCode.Forbidden) {
        setApiLoader(false);
        setDragHighlight(false);
        setError(response.data.message);
        // setOnBoardSnack(true);
        setProfileSnack(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // async function handleUpdateDetail() {

  //     let tempArr = [...addRowEmp];

  //     tempArr.push({
  //         "epName": epName,
  //         "epEmail": epEmail,
  //         "epDesignation": epDesignation,
  //         "licenceStatus": licenseStatus
  //     })
  //     setAddRowEmp([...tempArr]);

  //     handleCloseRegisterDialog();

  //     return;

  //     // try {

  //     //     let body = {
  //     //         "epName": epName,
  //     //         "epEmail": epEmail,
  //     //         "epDesignation": epDesignation,
  //     //         "licenceStatus": licenseStatus
  //     //     }

  //     //     if (!category) {
  //     //         delete body[category]
  //     //     }

  //     //     if (!subCategory) {
  //     //         delete body[subCategory]
  //     //     }

  //     //     setLoading(true);

  //     //     let response = await createEventController(body);

  //     //     setLoading(false);
  //     //     console.log(response, "response");

  //     //     if (response.status === HttpStatusCode.Ok) {

  //     //         // setCategory("");
  //     //         // setDescription("");

  //     //         // update the category list
  //     //         // let tempArray = [...sub_IncidentDataList];
  //     //         // tempArray.push(response.data.data.saveIncidentData)

  //     //         // setincidentDataList(prev => [...prev, response.data.data.saveIncidentData]);

  //     //         // setSub_IncidentDataList(tempArray)

  //     //         // close dialog box
  //     //         // handleCloseCreateDialog();

  //     //     } else {
  //     //         // if any error message show the message to user
  //     //         if (typeof (response?.data?.message) === 'string' || (response?.data?.message) instanceof String) {

  //     //             // handleOpenSnackbar(response?.data?.message, SnackbarStatusType.warning);
  //     //         } else if (typeof (response?.data?.error) === 'string' || (response?.data?.error) instanceof String) {

  //     //             // handleOpenSnackbar(response?.data?.error, SnackbarStatusType.warning);
  //     //         } else if (typeof (response.data) === 'string' || (response.data) instanceof String) {

  //     //             // handleOpenSnackbar(response?.data, SnackbarStatusType.warning);
  //     //         }
  //     //     }
  //     // } catch (err) {
  //     //     console.log("Error in Create Event : ", err);
  //     // }

  // }

  useEffect(() => {
    setEpName(registerDetails.epName);
    setEpEmail(registerDetails.epEmail);
    setEpDesignation(registerDetails.epDesignation);
    setLicenseStatus(registerDetails.licenseStatus);
  }, [registerDetails]);

  return (
    <Dialog
      onClose={handleCloseRegisterDialog}
      open={isOpenUploadEmployeeDialog}
      sx={{
        "& .MuiDialog-paper": {
          minWidth: "50%",
          //  minHeight: "60vh"
        },
      }}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h4">Upload Employee</Typography>

          <Box display="flex" alignItems="center" gap={2}>
            <IconButtonMA
              disabled={
                epName === ""
                  ? true
                  : epEmail === ""
                  ? true
                  : epDesignation === ""
                  ? true
                  : licenseStatus === ""
                  ? true
                  : false
              }
              size="small"
              onClick={handleCloseRegisterDialog}
            >
              <Upload />
            </IconButtonMA>
            <IconButtonMA size="small" onClick={handleCloseRegisterDialog}>
              <Close />
            </IconButtonMA>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ px: 1.5 }}>
        <Box py={0.8} display="flex" flexDirection="column" gap={2}>
          <Box
            display="flex"
            alignItems="center"
            droppable
            onAllowDrop={() => console.log("drop")}
            onDragOver={(e) => {
              console.log(e.dataTransfer.files[0], "type");
              e.preventDefault();
              setDragHighlight(true);
              console.log("drops");
            }}
            onDragLeave={(e) => {
              e.preventDefault();
              setDragHighlight(false);

              console.log("dropEnd");
            }}
            onDrop={onDrop}
            height="100%"
            borderRadius="8px"
            backgroundColor={theme.col_4}
            flexDirection="column"
            justifyContent="center"
            gap="21px"
            border={`2px dashed ${dragHighlight ? theme.col_2 : theme.col_3}`}
          >
            {apiLoader ? (
              <Box
                display="flex"
                alignItems="center"
                flexDirection="column"
                width={"100%"}
                height="100%"
                justifyContent="center"
              >
                <CircularProgress sx={{ color: theme.col_2 }} size="50px" />
              </Box>
            ) : (
              <>
                {dragHighlight ? (
                  <Typography
                    fontFamily={font.family.fm_2}
                    textTransform={"capitalize"}
                    fontSize={font.size.fs_2}
                    fontWeight="bold"
                    color={theme.col_2}
                  >
                    Drop here
                  </Typography>
                ) : (
                  <>
                    {!csvFile.name ? (
                      <>
                        {" "}
                        <Typography
                          fontFamily={font.family.fm_2}
                          textTransform={"capitalize"}
                          fontSize={font.size.fs_2}
                          fontWeight="bold"
                          color={theme.col_2}
                        >
                          Drag & Drop
                        </Typography>
                        <Typography
                          fontFamily={font.family.fm_2}
                          textTransform={"capitalize"}
                          fontSize={font.size.fs_3}
                          fontWeight="bold"
                          color={theme.col_3}
                        >
                          or
                        </Typography>
                      </>
                    ) : (
                      <Box
                        minWidth="40%"
                        padding="6px"
                        height="40px"
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        borderRadius="10px"
                        backgroundColor={theme.col_2_alpha}
                      >
                        <Typography
                          fontFamily={font.family.fm_2}
                          textTransform={"capitalize"}
                          fontSize={font.size.fs_3}
                          fontWeight="bold"
                          color={theme.col_2}
                        >
                          File Name : {csvFile?.name.slice(0, 12)}
                        </Typography>
                      </Box>
                    )}
                    <Box width={"40%"}>
                      <ButtonCustom
                        disabled={false}
                        fullWidth={true}
                        onClick={() =>
                          document.getElementById("inputClick").click()
                        }
                        background={theme.col_2_alpha}
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        backgroundRipple={theme.col_3_alpha}
                        focusColor={theme.col_2}
                        typography={
                          <Typography
                            fontFamily={font.family.fm_2}
                            textTransform={"capitalize"}
                            fontSize={font.size.fs_3}
                            fontWeight="bold"
                            color={theme.col_2}
                          >
                            Upload CSV
                          </Typography>
                        }

                        //   startIcon={items.icon}
                      />

                      <VisuallyHiddenInput
                        onChange={onFileSelect}
                        id="inputClick"
                        type="file"
                        accept=".csv"
                      />
                    </Box>
                  </>
                )}
              </>
            )}
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
